
import React from "react";
import { Modal, Button } from "react-bootstrap";

const ClientDetailModal = ({ show, onHide, client, user }) => {
  if (!client) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return Number.isNaN(date.getTime())
      ? "N/A"
      : date.toLocaleDateString(undefined, {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
  };

  const hasGST =
    client.hasGST === true ||
    String(client.hasGST).toLowerCase() === "true";

  const gstDetails = client.gstDetails || {};

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Client Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <strong>Name:</strong> {client.name || "N/A"}
        </p>
        <p>
          <strong>Buyer Name:</strong> {client.buyerName || "N/A"}
        </p>
        <p>
          <strong>Shift In:</strong> {client.shift_hours?.check_in || "N/A"}
        </p>
        <p>
          <strong>Shift Out:</strong> {client.shift_hours?.check_out || "N/A"}
        </p>
        <p>
          <strong>Salary:</strong> {client.salary ?? "N/A"}
        </p>
        <p>
          <strong>Payout:</strong> {client.payout ?? "N/A"}
        </p>
        <p>
          <strong>Payouts Per Packet:</strong>{" "}
          {client.payoutperpacket ?? "N/A"}
        </p>
        <p>
          <strong>OT Rate:</strong> {client.otRate ?? 0}
        </p>
        <p>
          <strong>Extra KM Rate:</strong> {client.extrakmRate ?? 0}
        </p>
        <p>
          <strong>Hub:</strong> {client.id_hub?.name || "N/A"}
        </p>
        <p>
          <strong>On-Boarding Date:</strong>{" "}
          {formatDate(client.onBoardingDate)}
        </p>
        <p>
          <strong>Shift:</strong> {client.shift || "N/A"}
        </p>
        <p>
          <strong>Adhoc Amount:</strong> {client.adhocAmount ?? "N/A"}
        </p>
        <p>
          <strong>Status:</strong> {client.status || "N/A"}
        </p>
        <p>
          <strong>Contact Name:</strong> {client.contactname || "N/A"}
        </p>
        <p>
          <strong>Phonenumber:</strong> {client.phonenumber ?? "N/A"}
        </p>
        <p>
          <strong>Designation:</strong> {client.designation || "N/A"}
        </p>

        <hr />
        <h6>GST Details</h6>
        <p>
          <strong>GST Applicable:</strong> {hasGST ? "Yes" : "No"}
        </p>

        {hasGST && (
          <>
            <p>
              <strong>GST Number:</strong> {gstDetails.gstNumber || "N/A"}
            </p>
            <p>
              <strong>GST Percentage:</strong>{" "}
              {gstDetails.gstPercentage ?? 0}%
            </p>
            <p>
              <strong>TDS Percentage:</strong>{" "}
              {gstDetails.tdsPercentage ?? 0}%
            </p>
          </>
        )}

        <p>
          <strong>Created Date:</strong> {formatDate(client.createdAt)}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ClientDetailModal;
